import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ProblemDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.ProblemDetailPage })));
const ProblemFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.ProblemFormPage })));
const ProblemListPage = lazy(() => import('./list-page').then((m) => ({ default: m.ProblemListPage })));

export const problemRoutes: RouteObject[] = [
  {
    path: 'problems',
    handle: { crumb: 'Problem Tracking' },
    children: [
      { index: true, element: <ProblemListPage /> },
      { path: 'new', element: <ProblemFormPage />, handle: { crumb: 'New problem' } },
      { path: ':id', element: <ProblemDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Problem' } },
    ],
  },
];
